import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';

// Utility function to check if a JWT token has expired
export const isTokenExpired = (token) => {
  if (!token) {
    return true;
  }

  const payload = token.split(".")[1];
  const decodedPayload = JSON.parse(window.atob(payload)); // Decode from base64
  const expiry = decodedPayload.exp;
  const now = Math.floor(Date.now() / 1000); // Current time in Unix timestamp

  console.log("Token expiry:", expiry);
  return expiry < now; // Returns true if the token has expired
};

// Utility function to refresh the JWT token
export const refreshToken = async (token) => {
  try {
    const response = await axios.post(`${backendUrl}/token-refresh`, { token });
    const newToken = response.data.token;
    localStorage.setItem('authToken', newToken); // Save the new token to local storage
    return newToken;
  } catch (error) {
    console.error('Error refreshing token:', error);
    throw new Error('Token refresh failed');
  }
};
